import { render, staticRenderFns } from "./BloomBreeder.vue?vue&type=template&id=e4e1035e&scoped=true"
import script from "./BloomBreeder.vue?vue&type=script&lang=js"
export * from "./BloomBreeder.vue?vue&type=script&lang=js"
import style0 from "./BloomBreeder.vue?vue&type=style&index=0&id=e4e1035e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e1035e",
  null
  
)

export default component.exports